import { render, staticRenderFns } from "./TemplateCreateEditor.vue?vue&type=template&id=9f8aa186&"
import script from "./TemplateCreateEditor.vue?vue&type=script&lang=js&"
export * from "./TemplateCreateEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports